


import {
  defineComponent,
  reactive,
} from '@vue/composition-api';
import useSettouSagyou from '@/components/Sp/Johaisetsu/SettouSagyou/composables/useSettouSagyou';

interface State {
  showConfirmStartWorkingModal: boolean;
}

export default defineComponent({
  props: {
    selectedJohaisetsuType: {
      type: String,
      required: true,
    },
    isRequesting: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit }) {
    const state = reactive<State>({
      showConfirmStartWorkingModal: false,
    });
    const {
      johaisetsuTypeGroupName,
      johaisetsuTypeNameDisp,
    } = useSettouSagyou({ selectedJohaisetsuType: props.selectedJohaisetsuType });
    const tryShowConfirmStartWorkingModal = () => {
      state.showConfirmStartWorkingModal = true;
    };
    const editContentAndRoad = () => {
      emit('editContentAndRoadOnCommon');
    };
    const startWorking = () => {
      state.showConfirmStartWorkingModal = false;
      emit('startWorkingOnCommon');
    };
    return {
      state,
      johaisetsuTypeGroupName,
      johaisetsuTypeNameDisp,
      startWorking,
      editContentAndRoad,
      tryShowConfirmStartWorkingModal,
    };
  },
});
